import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Import test utilities for development
if (import.meta.env.DEV) {
  import('./utils/test-auth-integration');
}

createRoot(document.getElementById('root')!).render(
  <App />,
)
